import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Box,
} from "@mui/material";

const OpportunityModal = ({ openOpportunity, onClose }) => {
  const isOpen = Boolean(openOpportunity);
  const isRetention = openOpportunity?.type === "retention";

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, fontSize: "1rem" }}>
        {openOpportunity?.title}
      </DialogTitle>

      <DialogContent dividers>
        {/* Retention-only: Linked Risk */}
        {isRetention && openOpportunity?.linked_risk && (
          <>
            <Typography
              sx={{
                fontSize: "0.8rem",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: 0.4,
                color: "#6b7280",
                mb: 0.5,
              }}
            >
              Linked Risk
            </Typography>

            <Typography
              sx={{ fontSize: "0.92rem", color: "#374151", mb: 1.75 }}
            >
              {openOpportunity.linked_risk}
            </Typography>

            <Divider sx={{ mb: 1.75 }} />
          </>
        )}

        {/* Retention-only: Issue / Recommended action (if present) */}
        {isRetention &&
          (openOpportunity?.issue || openOpportunity?.recommended_action) && (
            <>
              {openOpportunity?.issue && (
                <Box sx={{ mb: 1.5 }}>
                  <Typography
                    sx={{
                      fontSize: "0.8rem",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 0.4,
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Issue
                  </Typography>
                  <Typography sx={{ fontSize: "0.92rem", color: "#374151" }}>
                    {openOpportunity.issue}
                  </Typography>
                </Box>
              )}

              {openOpportunity?.recommended_action && (
                <Box sx={{ mb: 1.75 }}>
                  <Typography
                    sx={{
                      fontSize: "0.8rem",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: 0.4,
                      color: "#6b7280",
                      mb: 0.5,
                    }}
                  >
                    Recommended Action
                  </Typography>
                  <Typography sx={{ fontSize: "0.92rem", color: "#374151" }}>
                    {openOpportunity.recommended_action}
                  </Typography>
                </Box>
              )}

              <Divider sx={{ mb: 1.75 }} />
            </>
          )}

        {/* Rationale (both types) */}
        {!isRetention && (
          <Typography
            sx={{
              fontSize: "0.8rem",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: 0.4,
              color: "#6b7280",
              mb: 0.5,
            }}
          >
            Rationale
          </Typography>
        )}

        {!isRetention && (
          <Typography
            sx={{
              fontSize: "0.92rem",
              color: "#4b5563",
              whiteSpace: "pre-line",
            }}
          >
            {openOpportunity?.rationale || "—"}
          </Typography>
        )}
        {/* Examples (cross-sell typically, but safe for both) */}
        {Array.isArray(openOpportunity?.examples) &&
          openOpportunity.examples.length > 0 && (
            <>
              <Divider sx={{ my: 1.75 }} />
              <Typography
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: 0.4,
                  color: "#6b7280",
                  mb: 0.75,
                }}
              >
                Examples
              </Typography>

              <Box component="ul" sx={{ m: 0, pl: 2.25 }}>
                {openOpportunity.examples.map((ex, idx) => (
                  <Box
                    component="li"
                    key={`${openOpportunity?.id || "opp"}-ex-${idx}`}
                    sx={{ fontSize: "0.92rem", color: "#374151", mb: 0.5 }}
                  >
                    {ex}
                  </Box>
                ))}
              </Box>
            </>
          )}
      </DialogContent>

      <DialogActions sx={{ px: 2, py: 1.5 }}>
        <Button
          onClick={onClose}
          variant="contained"
          size="small"
          sx={{ textTransform: "none", borderRadius: "999px", px: 2.75 }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OpportunityModal;
